<template>
  <v-dialog
    v-model="internalShow"
    persistent
    width="500"
    overlay-opacity="0.59"
  >
    <v-card
      min-height="600"
      class="d-flex flex-column justify-space-between"
      elevation="10"
    >
      <v-img
        src="./../assets/clearfxai-logo.png"
        aspect-ratio="16/9"
        max-height="90"
        class="mt-8"
        contain
      ></v-img>

      <v-card-title class="text-h6 justify-center font-weight-bold">
        {{ $t('buyDialog.title') }}
      </v-card-title>

      <v-card-text class="text-subtitle-1 text-center px-6">
        <span>{{ $t('buyDialog.instruction.instructionOne') }}</span>
        <br><br>
        {{ $t('buyDialog.instruction.instructionTwo') }}
        <br><br>
        {{ $t('buyDialog.instruction.instructionThree') }}
      </v-card-text>

      <v-card-actions class="d-flex pb-6">
        <v-spacer></v-spacer>
        <v-btn text @click="close()">
          {{ $t('instructions.cancel') }}
        </v-btn>

        <v-btn
          color="primary"
          class="font-weight-bold"
          @click="sendEmail"
        >
          {{ $t('buyDialog.getGridpro') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'BuyDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      internalShow: this.value
    }
  },
  watch: {
    value (val) {
      this.internalShow = val
    },
    internalShow (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    close () {
      this.$router.replace('/grid/fxmarket')
      this.internalShow = false
    },
    sendEmail () {
      const subject = encodeURIComponent(this.$t('buyDialog.accessRequest'))

      window.location.href = `mailto:support@clearfxai.com?subject=${subject}`
    },
  }
}
</script>